// src/pages/DirectExpenseLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import DirectExpenseFilters from "./components/DirectExpenseFilters";
import DirectExpenseTable from "./components/DirectExpenseTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const DirectExpenseLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.directExpenseLedger);
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Direct Expense Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Direct Expense Balance Ledger
            </Title>
            </div>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <DirectExpenseFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <DirectExpenseTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Direct Expense Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DirectExpenseTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DirectExpenseLedger;
